var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 bottom-0 w-full h-full"},[_c('SpeakerList',{attrs:{"active":true,"isStage":true,"showHeader":true,"listHeight":80.4,"stageFilterDesign":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }